import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import {
  PUPIL_CONTEXT_FEATURE_KEY,
  pupilContextReducer,
} from './+state/pupil-context/pupil-context.reducer';

export function providePupilContext(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(PUPIL_CONTEXT_FEATURE_KEY, pupilContextReducer),
  ]);
}
